import * as React from 'react';
import { Flex } from "../../flex";
import { Box } from "../../box";
import { Button } from "../../button";
import { Text } from "../../text";
import { Subheading } from "../../subheading";
import useTimeout from "../../../hooks/useTimeout";
import Time from "../../../constants/time";
import { getToastItemStyles, getToastCloseButtonStyles } from "./ToastItem.styles";
export var ToastItem = function ToastItem(_ref) {
  var content = _ref.content,
      title = _ref.title,
      palette = _ref.palette,
      action = _ref.action,
      onClose = _ref.onClose,
      _ref$autoHideDuration = _ref.autoHideDuration,
      autoHideDuration = _ref$autoHideDuration === void 0 ? 15 * Time.sec : _ref$autoHideDuration,
      onAction = _ref.onAction,
      icon = _ref.icon;
  useTimeout(function () {
    onClose();
  }, autoHideDuration);
  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    sx: getToastItemStyles({
      palette: palette
    })
  }, icon && /*#__PURE__*/React.createElement(Flex, null, icon), /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    my: 3,
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "white",
    fontWeight: "medium",
    fontSize: 1,
    py: 1
  }, title), content && /*#__PURE__*/React.createElement(Subheading, {
    fontSize: 1
  }, content)), action && /*#__PURE__*/React.createElement(Flex, {
    flex: "none"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    palette: palette,
    onClick: function onClick() {
      return onAction === null || onAction === void 0 ? void 0 : onAction();
    }
  }, action)), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Button, {
    appearance: "icon",
    palette: "neutral",
    icon: "cross",
    size: "medium",
    sx: getToastCloseButtonStyles(),
    onClick: function onClick() {
      return onClose();
    }
  })));
};